module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tktQrOrder) ? _c('div', {
    staticClass: "qr_popup"
  }, [_c('div', {
    staticClass: "bg",
    on: {
      "click": _vm.resetTktQr
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pop_up"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("tickets_and_bar.operations.tickets")))]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.resetTktQr
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "tickets-center"
  }, [(_vm.winW > 1024) ? _c('div', {
    staticClass: "tickets-top"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("pop_ups.qr_code.ticket")) + " "), _c('span', [_vm._v("#" + _vm._s(_vm.tktQrIndex + 1))])]) : _vm._e(), _vm._v(" "), (_vm.winW <= 1024) ? _c('div', {
    staticClass: "mobile-qrs",
    class: {
      'center-it': _vm.tktQrOrder.tickets.length == 1
    }
  }, _vm._l((_vm.tktQrOrder.tickets), function(ticket, ticketNum) {
    return _c('div', {
      key: ticketNum,
      staticClass: "mobile-qr"
    }, [_c('div', {
      staticClass: "tickets-top"
    }, [_vm._v("\n              " + _vm._s(_vm.$t("pop_ups.qr_code.ticket")) + " "), _c('span', [_vm._v("#" + _vm._s(ticketNum + 1))])]), _vm._v(" "), _c('qrcode', {
      attrs: {
        "value": _vm.mobileTickets(ticketNum),
        "options": {
          size: 208
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tickets-bottom"
    }, [_c('p', {
      staticClass: "ticket_info"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t("pop_ups.qr_code.row")) + ": " + _vm._s(_vm.tktQrOrder.tickets[ticketNum].row))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("pop_ups.qr_code.place")) + ": " + _vm._s(_vm.tktQrOrder.tickets[ticketNum].seat))])]), _vm._v(" "), _c('p', {
      staticClass: "bar_hint"
    }, [_vm._v(_vm._s(_vm.mobileTickets(ticketNum)))])])], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.winW > 1024) ? _c('qrcode', {
    attrs: {
      "value": _vm.qrValue,
      "options": {
        size: 208
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.winW > 1024) ? _c('div', {
    staticClass: "tickets-bottom"
  }, [_c('p', {
    staticClass: "ticket_info"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("pop_ups.qr_code.row")) + ": " + _vm._s(_vm.tktQrOrder.tickets[_vm.tktQrIndex].row))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("pop_ups.qr_code.place")) + ": " + _vm._s(_vm.tktQrOrder.tickets[_vm.tktQrIndex].seat))])]), _vm._v(" "), _c('p', {
    staticClass: "bar_hint"
  }, [_vm._v(_vm._s(_vm.qrValue))])]) : _vm._e()], 1), _vm._v(" "), (_vm.tktQrOrder.tickets.length > 1 && _vm.tktQrIndex > 0 && _vm.winW > 1024) ? _c('div', {
    staticClass: "dec",
    on: {
      "click": _vm.decrementTktQr
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "37",
      "height": "65"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35.586 0h-34v65h34z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M1.586 1.405L2.995 0l32.59 32.5L2.996 65l-1.41-1.405L32.768 32.5z"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.tktQrOrder.tickets.length > 1 && _vm.tktQrIndex < _vm.tktQrOrder.tickets.length - 1 && _vm.winW > 1024) ? _c('div', {
    staticClass: "inc",
    on: {
      "click": _vm.incrementTktQr
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "37",
      "height": "65"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35.586 0h-34v65h34z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M1.586 1.405L2.995 0l32.59 32.5L2.996 65l-1.41-1.405L32.768 32.5z"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "bar_hint"
  }, [_vm._v(_vm._s(_vm.$t("commons.bar_hint")))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08d30378","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-ups/qr-code.vue
// module id = 396
// module chunks = 1